import { render, staticRenderFns } from "./SubscriptionFAQ.vue?vue&type=template&id=0d29e844&"
import script from "./SubscriptionFAQ.vue?vue&type=script&lang=js&"
export * from "./SubscriptionFAQ.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionFAQ.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports